module.exports = __webpack_public_path__ + "static/img/rank_278.a84d13a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_278.png
// module id = iJ0P
// module chunks = 1